import * as React from 'react'
import MuiDrawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'

import usePageInfo from '../../hooks/usePageInfo'

import { DrawerItems } from './DrawerItems'

const Drawer = React.memo(({ open, onClose }) => {
    const { label } = usePageInfo()

    const items = React.useMemo(() => <DrawerItems />, [])

    return (
        <>
            <MuiDrawer
                open={open}
                onClose={onClose}
                elevation={8}
                componentsProps={{
                    backdrop: {
                        invisible: true,
                    },
                }}
                PaperProps={{
                    sx: {
                        position: 'relative',
                        whiteSpace: 'nowrap',
                        marginTop: 0,
                        width: theme => theme.spacing(41),
                        transition: theme =>
                            theme.transitions.create('width', {
                                easing: theme.transitions.easing.sharp,
                                duration:
                                    theme.transitions.duration.enteringScreen,
                            }),
                        boxSizing: 'border-box',
                    },
                }}
            >
                <Divider />
                <List component="nav">{items}</List>
            </MuiDrawer>
        </>
    )
})
export default Drawer
